import React from "react";
import ICurrentMember from "../../store/memberInterfaceStruct";

const labelStyle = { fontWeight: 600, fontSize: "1.1em" };
const fieldStyle = { border: "1px solid #ccc", padding: "2px 6px", minWidth: 120, background: "#f9f9f9" };

const formatValue = (value: any): string => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  return value.toString();
};

export const MemberPrintTemplate = ({ member }: { member: ICurrentMember }) => (
  <>
  <style>
    {`
      @media print {
        .printA4Sheet-div {
          width: 100% !important;
          max-width: 800px !important;
          margin: 0 auto !important;
          box-shadow: none !important;
        }
        body {
          background: #fff !important;
        }
      }
    `}
  </style>
  <div style={{
    maxWidth: 800,
    width: "100%",
    margin: "0 auto",
    background: "#fff",
    border: "0px solid #ccc",
    boxSizing: "border-box",
    padding: 16,
    fontFamily: "Arial, Helvetica, sans-serif"
  }}>
    <div style={{ textAlign: "center", fontWeight: "bold", fontSize: 32, marginBottom: 8 }}>
      Delaware State Bar Association
    </div>
    <div style={{ textAlign: "center", fontSize: 20, marginBottom: 16 }}>
      Member Information
    </div>
    <div style={{ textAlign: "center", fontSize: 18, fontWeight: 600, marginBottom: 12 }}>
      {member?.FirstName?.trim() + " " + member?.LastName?.trim() || "-"}, {formatValue(member?.Esquire)}.
    </div>
    {/* Top Info Grid */}
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
      <div>
        <div><b>Bar ID</b></div>
        <div style={fieldStyle}>{formatValue(member?.BarId)}</div>
      </div>
      <div>
        <div><b>Member Code</b></div>
        <div style={fieldStyle}>{formatValue(member?.MemberCode)}</div>
      </div>
      <div>
        <div><b>Last Paid Dues</b></div>
        <div style={fieldStyle}>{formatValue(member?.LastMembershipDuePaidOn)}</div>
      </div>
      <div>
        <div><b>Last Update</b></div>
        <div style={fieldStyle}>{formatValue(member?.UpdatedAt)}</div>
      </div>
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
      <div>
        <div><b>Admit Date</b></div>
        <div style={fieldStyle}>{formatValue(member?.AdmitDate)}</div>
      </div>
      <div>
        <div><b>Years Admitted</b></div>
        <div style={fieldStyle}>{formatValue(member?.YearsAdmitted)}</div>
      </div>
      <div>
        <div><b>Gender</b></div>
        <div style={fieldStyle}>{formatValue(member?.Gender)}</div>
      </div>
      <div>
        <div><b>Birthdate</b></div>
        <div style={fieldStyle}>{formatValue(member?.DateOfBirth)}</div>
      </div>

    </div>
    {/* Addresses */}
    <div style={{ display: "flex", gap: 16, marginTop: 16 }}>
      {/* Primary Address */}
      <div style={{ flex: 1 }}>
        <div style={labelStyle}>Primary Address</div>
        <div><b>Firm</b>        <div style={fieldStyle}>{formatValue(member?.PrimaryAddress?.FirmName)}</div></div>
        <div><b>Address</b>        <div style={fieldStyle}>{formatValue(member?.PrimaryAddress?.Address1)}</div></div>
        <div><b>Address 2</b>        <div style={fieldStyle}>{formatValue(member?.PrimaryAddress?.Address2)}</div></div>
        <div><b>City</b>        <div style={fieldStyle}>{formatValue(member?.PrimaryAddress?.City)}</div></div>
        <div><b>County/State</b>        <div style={fieldStyle}>{formatValue(member?.PrimaryAddress?.County) + " " + formatValue(member?.PrimaryAddress?.State)}</div></div>
        <div><b>Zip</b>        <div style={fieldStyle}>{formatValue(member?.PrimaryAddress?.Zipcode)}</div></div>
        
        <div><b>Phone</b>        <div style={fieldStyle}>{formatValue(member?.PrimaryAddress?.PhoneNumber)}</div></div>
        <div><b>Fax</b>        <div style={fieldStyle}>{formatValue(member?.PrimaryAddress?.FaxNumber)}</div></div>
        <div><b>Email</b>        <div style={fieldStyle}>{formatValue(member?.PrimaryAddress?.Email)}</div></div>
      </div>
      {/* Published Address */}
      <div style={{ flex: 1 }}>
        <div style={labelStyle}>Published Address</div>
        <div><b>Firm</b>        <div style={fieldStyle}>{formatValue(member?.PublishedAddress?.FirmName)}</div></div>
        <div><b>Address</b>        <div style={fieldStyle}>{formatValue(member?.PublishedAddress?.Address1)}</div></div>
        <div><b>Address 2</b>        <div style={fieldStyle}>{formatValue(member?.PublishedAddress?.Address2)}</div></div>
        <div><b>City</b>        <div style={fieldStyle}>{formatValue(member?.PublishedAddress?.City)}</div></div>
        <div><b>County/State</b>        <div style={fieldStyle}>{formatValue(member?.PublishedAddress?.County) + " " + formatValue(member?.PublishedAddress?.State)}</div></div>
        <div><b>Zip</b>        <div style={fieldStyle}>{formatValue(member?.PublishedAddress?.Zipcode)}</div></div>
        <div><b>Phone</b>        <div style={fieldStyle}>{formatValue(member?.PublishedAddress?.PhoneNumber)}</div></div>
        <div><b>Fax</b>        <div style={fieldStyle}>{formatValue(member?.PublishedAddress?.FaxNumber)}</div></div>
        <div><b>Email</b>        <div style={fieldStyle}>{formatValue(member?.PublishedAddress?.Email)}</div></div>
      </div>
    </div>
    {/* Misc Info */}
    {/* <div style={{ marginTop: 24 , display: "none"}}>
      <div style={labelStyle}>Misc. Information</div>
      <div style={{ display: "flex", gap: 16 }}>
        <div style={{ flex: 1 }}>
          <div><b>Committees Chaired</b></div>
          <div style={{ ...fieldStyle, minHeight: 80 }}>{member?.misc?.committeesChaired || ""}</div>
        </div>
        <div style={{ flex: 1 }}>
          <div>
            <div>Past President <input type="checkbox" checked={!!member?.misc?.pastPresident} readOnly /></div>
            <div>Executive Committee <input type="checkbox" checked={!!member?.misc?.executiveCommittee} readOnly /></div>
            <div>Nominating Committee <input type="checkbox" checked={!!member?.misc?.nominatingCommittee} readOnly /></div>
            <div>Prof. Ethics Committee <input type="checkbox" checked={!!member?.misc?.profEthicsCommittee} readOnly /></div>
            <div>Lawyer Referral Panel <input type="checkbox" checked={!!member?.misc?.lawyerReferralPanel} readOnly /></div>
            <div>Other St. Bars <span style={fieldStyle}>{member?.misc?.otherStBars || ""}</span></div>
            <div>Printed DLR <input type="checkbox" checked={!!member?.misc?.printedDLR} readOnly /></div>
          </div>
        </div>
      </div>
    </div> */}
  </div>
  </>
);